module.exports = __webpack_public_path__ + "static/media/useless-certifications-cover.0f647a24.png";